// x-base.js

/*
This script contains a variety of base functions for all x-sites
*/

export default function xBase() {

  /**********************************************************************************
  Vortex admin preview iframe height update

  Prevents vertical scrollbar in preview iframe if document is taller than it.
  Can occur due to delays, accordions being opened, lazy images, etc.
  Limits to number of updates and document height to prevent loops etc.
  ***********************************************************************************/

  if (window.name === "previewViewIframe") {
    let resizeTimeout;
    let updateCount = 0;
    const maxUpdateCount = 10;
    const maxHeightThreshold = 50000;

    // Function to check document and viewport height
    function checkHeights() {
      // Clear any existing timeout
      clearTimeout(resizeTimeout);

      // Update height after resizing has stopped for a short while
      resizeTimeout = setTimeout(() => {
        // Check if vrtx and vrtx.previewHeightUpdate are defined before calling
        if (typeof vrtx !== "undefined" && typeof vrtx.previewHeightUpdate === "function") {
          const documentHeight = document.documentElement.scrollHeight;

          // Run update unless page is taller than threshold
          if (documentHeight < maxHeightThreshold) {
            // Increment the update counter
            updateCount++;

            // Log debug info (needs console set to verbose level to see)
            console.debug("X: Iframe height updated:", documentHeight, window.innerHeight);

            // Run update
            vrtx.previewHeightUpdate();

            // Clear resize observer if max number of updates is reached
            if (updateCount >= maxUpdateCount) {
              console.log("X: Max number of iframe height updates reached.");
              resizeObserver.disconnect();
            }
          }
          else {
            console.log("X: Document very tall. Stopped updating iframe height.");
          }
        }
        else {
          console.error("X: Failed to update iframe height");
        }
      }, 500); // Time after resizing stops until height is updated
    }

    // Create and use a ResizeObserver to observe changes in height
    const resizeObserver = new ResizeObserver(entries => {
      checkHeights();
    });

    // Start observing the document element for size changes
    resizeObserver.observe(document.documentElement);
  }



  /**********************************************************************************
  vrtx mediaplayer

  - Get aspect ratio and enable as css variable through style
  - Add class if portrait ratio (taller than square)
  **********************************************************************************/

  const vrtxMediaPlayerIframes = document.querySelectorAll(".vrtx-media-player iframe");
  if (vrtxMediaPlayerIframes.length) {
    vrtxMediaPlayerIframes.forEach(iframe => {

      // Handle aspect ratio
      const videoWidth = parseFloat(iframe.getAttribute("data-video-width"));
      const videoHeight = parseFloat(iframe.getAttribute("data-video-height"));
      if (videoWidth && videoHeight) {
        const aspectRatio = videoWidth / videoHeight;

        // Set ratio as css variable through style
        iframe.style.setProperty("--video-aspect-ratio", aspectRatio);

        // Add class if portrait ratio
        if (videoHeight > videoWidth) {
          iframe.classList.add("portrait-ratio");
        }
      }
    });
  }



  /**********************************************************************************
  Filters form (used for employee- and exchange destination lists)

  - Align to page top when filtering
  **********************************************************************************/

  const filtersForm = document.querySelector("#filters-form");
  const activeFilterList = document.querySelector("ul.active-filters");
  // On load check for active filters and move to form anchor if present
  if (filtersForm && activeFilterList) {
    document.documentElement.classList.add("hard-scroll");
    window.location.hash = "filters-form";
  }
}
